<template>
  <span v-if="savedPercent" class='opc-price-save-count' :class="{
    'opc-price-save-count__disabled': disabled
  }">{{ $t('billing.common.save_count', [savedPercent]) }}</span>
</template>

<script setup>
import { computed } from 'vue';
import { savePercent } from '@/components/save-percent.js';

const props = defineProps({
  annualPrice: {
    type: Number,
    required: true
  },
  monthlyPrice: {
    type: Number,
    required: true
  },
  savedPercentValue: {
    type: [String, Number],
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const savedPercent = computed(() =>
  savePercent({
    savedPercentValue: props.savedPercentValue,
    monthlyPrice: props.monthlyPrice,
    annualPrice: props.annualPrice
  })
);
</script>

<style lang='scss' scoped>
.opc-price-save-count {
  text-align: center;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #FFFFFF;
  background: linear-gradient(96.59deg,#084845 10.36%,#09a639 89.64%);
  white-space: nowrap;

  &__disabled {
    background: #787878 !important;
    &.light {
      background: none !important;
      opacity: 0.5;
    }
  }

  &.light {
    color: #196830;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    text-transform: uppercase;
    border: 1px solid #9ECEAD;
    background: var(--zoom-color-fill-subtler-success, #F2FFF6);
  }
}
</style>
